import {Component, Inject, OnInit} from '@angular/core';
import {i18nService} from "../../service-utils/i18n.service";
import {FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-home-firefox-dialog',
  templateUrl: './home-firefox-dialog.component.html',
  styleUrls: ['./home-firefox-dialog.component.scss']
})
export class HomeFirefoxDialogComponent implements OnInit {

  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<HomeFirefoxDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public i18nService: i18nService
  ) {
  }

  ngOnInit(): void {
  }

  discard() {
    this.dialogRef.close();
  }

}
